const state = {
  closeout_purchases: [],
  closeout_purchase_ids: [],
  refresh_trigger: 0,
};

const getters = {
  getCloseoutPurchases: (state) => state.closeout_purchases,
  getCloseoutPurchaseIds: (state) => state.closeout_purchase_ids,
  getRefreshTrigger: (state) => state.refresh_trigger,
};

const mutations = {
  setCloseoutPurchases(state, value) {
    state.closeout_purchases = value;
  },
  setCloseoutPurchaseIds(state, value) {
    state.closeout_purchase_ids = value;
  },
  setRefreshTrigger(state, value) {
    state.refresh_trigger = value;
  },
};

const actions = {
  updateCloseoutPurchases(context, value) {
    context.commit("setCloseoutPurchases", value);
  },
  updateCloseoutPurchaseIds(context, value) {
    context.commit("setCloseoutPurchaseIds", value);
  },
  clearCloseoutPurchases(context) {
    context.commit("setCloseoutPurchases", []);
    context.commit("setCloseoutPurchaseIds", []);
  },
  refreshAllComponents(context) {
    context.commit("setRefreshTrigger", context.state.refresh_trigger + 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
